<template>
    <p v-show="glyphs">
        <canvas :class="$style.canvas" ref="glyphs" width="64" height="64"></canvas>
        <a class="btn btn-secondary btn-sm mr-3" role="button" ref="image" :download="`${urlCoords}_${glyphs}.png`">{{ $t('save_glyphs_image') }}</a>
        <b-check v-model="transparent" variant="secondary">transparent</b-check>
    </p>
</template>

<script>
import bCheck from 'bootstrap-vue/es/components/form-checkbox/form-checkbox';
import utils from '@/mixins/utils';

export default {
    props: {
        coords: String,
        glyphs: String
    },
    components: {
        bCheck
    },
    mixins: [
        utils
    ],
    data () {
        return {
            transparent: true
        };
    },
    methods: {
        draw () {
            const that = this;
            const canvas = this.$refs.glyphs;
            if (canvas.getContext) {
                const ctx = canvas.getContext('2d');
                const fontSize = canvas.height - 10;
                const theText = that.glyphs.split('').join(String.fromCharCode(8202));
                // const theText = that.glyphs.split('').join('');

                ctx.font = `${fontSize}px "glyphs-tight"`;

                const metrics = ctx.measureText(theText);
                canvas.width = metrics.width + 20;

                if (!that.transparent) {
                    ctx.fillStyle = '#1E2F36';
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    ctx.strokeStyle = '#E42200';
                    ctx.strokeRect(0.5, 0.5, canvas.width - 1, canvas.height - 1);
                }

                const x = 10;
                const y = canvas.height - 4;

                ctx.beginPath();
                ctx.font = `${fontSize}px "glyphs-tight"`;
                ctx.textBaseline = 'bottom';
                ctx.fillStyle = 'white';
                ctx.fillText(theText, x, y);

                const image = canvas.toDataURL('image/png');
                this.$refs.image.href = image;
            }
        }
    },
    mounted () {
        this.draw();
    },
    watch: {
        glyphs () {
            this.draw();
        },
        transparent () {
            this.draw();
        }
    }
};
</script>

<style module>
    .canvas {
        display: none;
    }
</style>
